import { render, staticRenderFns } from "./WizardConfigurationTabs.vue?vue&type=template&id=48f1b328&scoped=true&"
import script from "./WizardConfigurationTabs.vue?vue&type=script&lang=js&"
export * from "./WizardConfigurationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1b328",
  null
  
)

export default component.exports